import {Action, Condition, Event} from '@/model/types';

export const batch = (events: Event[], conditions: Condition[] = []) =>
  ({
    action: {
      type: 'batch',
      actions: events.map(event => event.action),
    },
    ...(conditions.length ? {conditions} : {}),
  }) as const;

export const set = <TField extends string, TValue>(field: TField, value: TValue, conditions: Condition[] = []) =>
  ({
    action: {
      type: 'set',
      field,
      value,
    },
    ...(conditions.length ? {conditions} : {}),
  }) as const;

export const unset = <TField extends string>(field: TField, conditions: Condition[] = []) =>
  ({
    action: {
      type: 'unset',
      field,
    },
    ...(conditions.length ? {conditions} : {}),
  }) as const;

export const batchUnset = (fields: string[]) => fields.map(field => unset(field)) satisfies Event[];

export const batchSet = (fieldsAndValues: Record<string, Extract<Action, {type: 'set'}>['value']>) =>
  Object.entries(fieldsAndValues).map(([field, value]) => set(field, value)) satisfies Event[];
